export const card = {
  slots: {
    root: "bg-(--ui-bg) ring ring-(--ui-border) divide-y divide-(--ui-border) rounded-[calc(var(--ui-radius)*2)] shadow-sm",
    header: "px-4 py-3 sm:px-4 sm:py-3",
    body: "px-4 py-3 sm:px-4 sm:py-3",
    footer: "px-4 py-3 sm:px-4 sm:py-3",
  },
};
